import React from "react";
import { useEffect, useState } from "react";
import { Button, Modal, Table, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import { db } from "../../utils/firebase";
import {
  collection,
  getDocs,
  query,
  where,
  orderBy,
  deleteDoc,
  doc,
} from "firebase/firestore";
import "./styles.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { useAuth } from "../../contexts/AuthContext";

const TransactionHistoryPageContent = () => {
  const { currentUser } = useAuth();
  const [order, setOrder] = useState(true);
  const [prevType, setPrevType] = useState(null);
  const [transactions, setTransactions] = useState([]);
  const transactionsCollectionRef = query(
    collection(db, "transactions"),
    where("uId", "==", currentUser.auth.currentUser.uid),
    orderBy("date", "desc")
  );
  const [modalInfo, setModalInfo] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [showDelete, setShowDelete] = useState(false);
  const handleDelete = () => {
    setShowDelete(!showDelete);
    setShow(!show);
  };

  const getTransactions = async () => {
    const data = await getDocs(transactionsCollectionRef);
    console.log(data); //...doc.data(), id: doc.id
    setTransactions(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
  };

  useEffect(() => {
    getTransactions();
  }, []);

  const sortByColumn = (type) => {
    var sortedTrans = [...transactions].sort((trans1, trans2) => {
      //date and amount, first click starts with descending
      if (["date", "amount"].includes(type)) {
        if (order && prevType === type) {
          //ascending
          return type === "amount"
            ? parseFloat(trans1[type]) > parseFloat(trans2[type])
              ? 1
              : -1
            : trans1[type] > trans2[type]
              ? 1
              : -1;
        } else {
          //descending
          return type === "amount"
            ? parseFloat(trans2[type]) > parseFloat(trans1[type])
              ? 1
              : -1
            : trans2[type] > trans1[type]
              ? 1
              : -1;
        }
      } else {
        //any column that is not 'date' or 'amount' starts with ascending
        if (order && prevType === type) {
          //descending
          return trans2[type].toLowerCase() > trans1[type].toLowerCase()
            ? 1
            : -1;
        } else {
          //ascending
          return trans1[type].toLowerCase() > trans2[type].toLowerCase()
            ? 1
            : -1;
        }
      }
    });
    setOrder(prevType === type && order ? false : true);
    setPrevType(type);
    setTransactions(sortedTrans);
  };

  const rowEvents = (transaction) => {
    console.log(transaction);
    setModalInfo(transaction);
    toggleTrueFalse();
  };

  const toggleTrueFalse = () => {
    setShowModal(handleShow);
  };

  const deleteTransaction = async () => {
    const transDoc = doc(db, "transactions", modalInfo.id);
    await deleteDoc(transDoc);
    setShowDelete(false);
    setShow(false);
    getTransactions();
  };

  const ModalContent = () => {
    return (
      <Modal centered show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <div className="title">
            <Modal.Title>Transaction Info</Modal.Title>
          </div>
          {/* <div className="editBtn"><Link to={`/transaction/edit/${modalInfo.id}`} className="btn btn-default" ><i className="bi bi-pencil fs-4" ></i></Link></div> */}
        </Modal.Header>
        <Modal.Body className="test">
          <p>
            <span className="modalBody">Date: </span>{" "}
            <span>{modalInfo.date}</span>
          </p>
          <p>
            <span className="modalBody">Merchant: </span>{" "}
            <span>{modalInfo.merchant}</span>
          </p>
          <p>
            <span className="modalBody">Amount: </span>{" "}
            <span>${parseFloat(modalInfo.amount).toFixed(2)}</span>
          </p>
          <p>
            <span className="modalBody">Category: </span>{" "}
            <span>{modalInfo.category}</span>
          </p>
          <p>
            <span className="modalBody">Type: </span>{" "}
            <span>{modalInfo.type}</span>
          </p>
          <p>
            <span className="modalBody">Description: </span>{" "}
            <span>{modalInfo.description}</span>
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={handleDelete}>
            Delete
          </Button>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  const ModalDelete = () => {
    return (
      <Modal centered show={showDelete} onHide={handleClose}>
        <Modal.Header>
          <Modal.Title>Delete Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to delete this transaction?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={deleteTransaction}>
            Delete
          </Button>
          <Button variant="secondary" onClick={handleDelete}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  return (
    <>
      <div className="bodyContent">
        <div className="row">
          <div className="col-md-6 text-left">
            <h1>Transaction History</h1>
            <p><em>Click a transaction to view its details, or to delete a transaction.</em></p>
          </div>
          <div className=" btn col-md-6 text-right">
            <Link to="/transaction/add" className="btn btn-success">
              Create
            </Link>
          </div>
        </div>
        <Table className="table" striped bordered hover>
          <thead>
            <tr className="header">
              <th onClick={() => sortByColumn("date")}>
                <span>
                  Date <i className="fa fa-sort"></i>
                </span>
              </th>
              <th onClick={() => sortByColumn("merchant")}>
                <span>
                  Merchant <i className="fa fa-sort"></i>
                </span>
              </th>
              <th onClick={() => sortByColumn("amount")}>
                <span>
                  Amount <i className="fa fa-sort"></i>
                </span>
              </th>
              <th onClick={() => sortByColumn("description")}>
                <span>
                  Description <i className="fa fa-sort"></i>
                </span>
              </th>
              <th onClick={() => sortByColumn("category")}>
                <span>
                  Category <i className="fa fa-sort"></i>
                </span>
              </th>
              <th onClick={() => sortByColumn("type")}>
                <span>
                  Type <i className="fa fa-sort"></i>
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            {transactions &&
              transactions.map((transaction) => {
                return (
                  <tr
                    key={transaction.id}
                    onClick={() => rowEvents(transaction)}
                  >
                    <td>{transaction.date}</td>
                    <td>{transaction.merchant}</td>
                    <td>${parseFloat(transaction.amount).toFixed(2)}</td>
                    <td>{transaction.description}</td>
                    <td>{transaction.category}</td>
                    <td>{transaction.type}</td>
                  </tr>
                );
              })}
          </tbody>
        </Table>
      </div>

      {show ? <ModalContent /> : null}
      {showDelete ? <ModalDelete /> : null}
    </>
  );
};

export default TransactionHistoryPageContent;
